import { createSelector } from 'reselect';

import { getLang } from '../../../../i18n/l10n';
import { SpineAnimationIds } from '../../../../types/animations';
import { Locales } from '../../../../types/common';
import { selectGRGlobalSkinId } from '../../../gift-race/selectors/global/globalPrimary.selector';
import { GRSkinIds } from '../../../gift-race/types/global';

const selectAnimationId = createSelector([selectGRGlobalSkinId], (skinId) => {
  const lang = getLang();

  if (skinId === GRSkinIds.GIFT_RACE) {
    if (lang === Locales.DE) {
      return SpineAnimationIds.GR_START_DE;
    }
    if (lang === Locales.EN) {
      return SpineAnimationIds.GR_START_EN;
    }
    if (lang === Locales.ES) {
      return SpineAnimationIds.GR_START_ES;
    }
    if (lang === Locales.FR) {
      return SpineAnimationIds.GR_START_FR;
    }
  }

  if (skinId === GRSkinIds.HUNTING_ALL_STARS) {
    return SpineAnimationIds.GR_HUNTING_ALL_STARS_WELCOME;
  }

  return null;
});

const selectGRWelcomeAnimationProps = createSelector([selectAnimationId], (animationId) => ({
  animationId,
}));

export default selectGRWelcomeAnimationProps;
